<template>
  <div class="container">
    <div class="row" v-if="showExplanation">
      <p>
        Enter your priest's name, server and region, and this tool will check how many of your Sindragosa kills suffer from the unchained magic bug. Will check for 10/25 (normal + heroic) kills. Only the first 5 unchained magic casts per fight are analysed (because as the fight drags on, ranged might die, causing a natural increase in healers afflicted).
      </p>
      <p>
        Note: if it wasn't your priest but another priest in your raid that experienced a bug, the system will still count that a a bug.
      </p>
    </div>

    <div class="row">
      <div class="input-group mb-2" style="width: 100%">
        <span class="input-group-text" id="basic-addon1">Priest Name</span>
        <input type="text" class="form-control" v-model="priestName">
      </div>
      <div class="input-group mb-2" style="width: 100%">
        <span class="input-group-text" id="basic-addon1">Server</span>
        <input type="text" class="form-control" v-model="server">
      </div>
      <div class="input-group mb-2" style="width: 100%">
        <span class="input-group-text" id="basic-addon1">Region</span>
        <input type="text" class="form-control" v-model="region">
      </div>
      <button v-if="!fetching" @click="pullData" class="btn btn-primary">Analyze</button>
      <button v-if="fetching" @click="pullData" class="btn btn-primary">Analyzing.......</button>
    </div>

    <div v-if="results" class="container margin-top-40 no-pad-left">
      <div v-for="(mode, modeIndex) in ['heroic_25', 'heroic_10', 'normal_25', 'normal_10']" :key="modeIndex">
        <div v-if="results[mode].length > 0">
          <h4>{{ mode }}</h4>
            <table class="table">
              <tr>
                <th>Link</th>
                <th>Is Bugged?</th>
                <th>Bugged Cast Index</th>
                <th>Bugged Healers</th>
              </tr>
              <tr v-for="(row, index) in results[mode]" :key="index">
                <td><a :href="row['link']" target="_blank">Link</a></td>
                <td>{{ row['isBugged'] }}</td>
                <td>{{ parseInt(row['buggedCastIndex']) + 1 }}</td>
                <td>{{ row['buggedHealers'] }}</td>
              </tr>
            </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios';

export default {
  name: 'SindragosaAnalyzer',
  metaInfo: {
    title: 'Sindragosa Analyzer',
  },
  data() {
    return {
      showExplanation: true,
      fetching: false,
      priestName: 'Joardeep',
      server: 'Benediction',
      region: 'US',
      results: null,
    };
  },
  computed: {
  },
  methods: {
    pullData() {
      this.fetching = true;
      this.results = null;
      let toPass = {priestName: this.priestName, server: this.server, region: this.region};
      axios
          .post(`analyzer/priest/sindragosa`, toPass)
          .then((response) => {
            this.fetching = false;
            if (response.data === '') {
              alert('No such character');
              return;
            }
            this.results = response.data;
            // if (this.results['data'].length > 0) {
            //   this.selectedRaptureIndex = 0;
            // }
            // this.currentFightId = Number(response.data['currentFightId']);
            // this.showExplanation = false;
          })
          .catch((error)  => {
            alert(error.response.data.message);
            this.fetching = false;
            this.showExplanation = false;
          });
    },
  },
  mounted() {
    console.log('mounting');
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.no-pad-left {
  padding-left: 0px;
}

.margin-top-40 {
  margin-top: 40px;
}

ul {
  list-style: none;
  padding-left: 0px;
  height: 600px;
  overflow: scroll;
}

li {
  cursor: pointer;
  padding: 10px 10px
}

li.selected {
  border: 5px #00b1ff;
  border-style: dashed;
}

li.missed {
  background: #f5c6cb;
}

li p {
  padding: 0px;
  margin: 0px;
}

/*background: #72ff0f;*/
</style>
